import * as actionTypes from '../Action/actionTypes';
import tag1 from '../../assets/img/tags/tag1.svg'
import tag2 from '../../assets/img/tags/tag2.svg'
import tag3 from '../../assets/img/tags/tag3.svg'
import tag4 from '../../assets/img/tags/tag4.svg'
import tag5 from '../../assets/img/tags/tag5.svg'

const initialState = {
  visitors: [],
  column: [

    // {index: 'tagColor', text: 'Tag Color', value: 'tagColor',image: {avatar: true, src: tag1}},
    {index: 'status', text: 'Status', value: 'status', /*image: {avatar: true, src: column_icon}*/},
    {index: 'passNumber', text: 'Pass Number', value: 'passNumber', /*image: {avatar: true, src: column_icon}*/},
    {index: 'checkedIn', text: 'Checked In', value: 'checkedIn', /*image: {avatar: true, src: column_icon}*/},
    {index: 'checkedOut', text: 'Checked Out', value: 'checkedOut', /*image: {avatar: true, src: column_icon}*/},
    {index: 'host1', text: 'Host1', value: 'host1', /*image: {avatar: true, src: column_icon}*/},
    {index: 'host1Mobile', text: 'Host1 Mobile', value: 'host1Mobile', /*image: {avatar: true, src: column_icon}*/},
    {index: 'host2', text: 'Host2', value: 'host2', /*image: {avatar: true, src: column_icon}*/},
    {index: 'host2Mobile', text: 'Host2 Mobile', value: 'host2Mobile', /*image: {avatar: true, src: column_icon}*/},
    {index: 'visitorName', text: 'Visitor', value: 'visitorName', /*image: {avatar: true, src: column_icon}*/},
    {
      index: 'visitorIdentity',
      text: 'Visitor Identity',
      value: 'visitorIdentity', /*image: {avatar: true, src: column_icon}*/
    },
    {
      index: 'visitorMobile',
      text: 'Visitor Mobile',
      value: 'visitorMobile', /*image: {avatar: true, src: column_icon}*/
    },
    {index: 'company', text: 'Company', value: 'company', /*image: {avatar: true, src: column_icon}*/},
    {
      index: 'visitingPurpose',
      text: 'Purpose of Visit',
      value: 'visitingPurpose', /*image: {avatar: true, src: column_icon}*/
    },
    {
      index: 'activatedPackage',
      text: 'Activated Package',
      value: 'activatedPackage', /*image: {avatar: true, src: column_icon}*/
    },
    {index: 'generatedPin', text: 'Generated Pin', value: 'generatedPin', /*image: {avatar: true, src: column_icon}*/},
    {index: 'expireDate', text: 'Expire Date', value: 'expireDate', /*image: {avatar: true, src: column_icon}*/}

  ],
  tags: [
    {
      key: 0,
      text: 'Yellow - VIP',
      value: '#d4ac1a',
      image: {avatar: true, src: tag1},
    },
    {
      key: 1,
      text: 'Green - Proper',
      value: '#0EC142',
      image: {avatar: true, src: tag2},
    },
    {
      key: 2,
      text: 'Blue - Regular',
      value: '#0b81b9',
      image: {avatar: true, src: tag3},
    },
    {
      key: 3,
      text: 'Red - Aggressive',
      value: '#FF0000',
      image: {avatar: true, src: tag4},
    },
    {
      key: 4,
      text: 'Grey - Anonymous',
      value: '#6f6f6f',
      image: {avatar: true, src: tag5},
    },
    //
  ],
  checkoutColumns: [
    {
      label: 'Check Out',
      field: 'checkOut',
      sort: 'asc'
    },
    {
      label: 'Tag Color',
      field: 'tagColor',
      sort: 'asc'
    },
    {
      label: 'Status',
      field: 'status',
      sort: 'asc'
    },
    {
      label: 'Pass Number',
      field: 'passNumber',
      sort: 'asc'
    },
    {
      label: 'Checked In',
      field: 'checkedIn',
      sort: 'asc'
    },
    {
      label: 'Checked Out',
      field: 'checkedOut',
      sort: 'asc'
    },
    {
      label: 'Host 1',
      field: 'host1',
      sort: 'asc',
    },
    {
      label: 'Host 1 Mobile',
      field: 'host1Mobile',
      sort: 'asc',
    },
    {
      label: 'Host 2',
      field: 'host2',
      sort: 'asc',
    },
    {
      label: 'Host 2 Mobile',
      field: 'host2Mobile',
      sort: 'asc',
    },
    {
      label: 'Visitor',
      field: 'visitor',
      sort: 'asc',
    },
    {
      label: 'Visitor Identity',
      field: 'visitorIdentity',
      sort: 'asc',
    },
    {
      label: 'Visitor Mobile',
      field: 'visitorMobile',
      sort: 'asc',
    },
    {
      label: 'Company',
      field: 'company',
      sort: 'asc',
    },
    {
      label: 'Purpose of Visit',
      field: 'purposeOfVisit',
      sort: 'asc',
    },
    {
      label: 'Activated Package',
      field: 'activatedPackage',
      sort: 'asc',
    },
    {
      label: 'Generated pin',
      field: 'generatedPin',
      sort: 'asc',
    },
    {
      label: 'Expire Date',
      field: 'expireDate',
      sort: 'asc',
    },
    {
      label: 'Registration Status',
      field: 'registrationStatus',
      sort: 'asc'
    },
    {
      label:'Receptionist Name',
      field: 'receptionName',
      sort: 'asc'
    }
  ],

  historyColumns: [

    {
      label: 'Tag Color',
      field: 'tagColor',
      sort: 'asc'
    },
    {
      label: 'Status',
      field: 'status',
      sort: 'asc'
    },
    {
      label: 'Pass Number',
      field: 'passNumber',
      sort: 'asc'
    },
    {
      label: 'Checked In',
      field: 'checkedIn',
      sort: 'asc'
    },
    {
      label: 'Checked Out',
      field: 'checkedOut',
      sort: 'asc'
    },
    {
      label: 'Host 1',
      field: 'host1',
      sort: 'asc',
    },
    {
      label: 'Host 1 Mobile',
      field: 'host1Mobile',
      sort: 'asc',
    },
    {
      label: 'Host 2',
      field: 'host2',
      sort: 'asc',
    },
    {
      label: 'Host 2 Mobile',
      field: 'host2Mobile',
      sort: 'asc',
    },
    {
      label: 'Visitor',
      field: 'visitor',
      sort: 'asc',
    },
    {
      label: 'Visitor Identity',
      field: 'visitorIdentity',
      sort: 'asc',
    },
    {
      label: 'Visitor Mobile',
      field: 'visitorMobile',
      sort: 'asc',
    },
    {
      label: 'Company',
      field: 'company',
      sort: 'asc',
    },
    {
      label: 'Purpose of Visit',
      field: 'purposeOfVisit',
      sort: 'asc',
    },
    {
      label: 'Activated Package',
      field: 'activatedPackage',
      sort: 'asc',
    },
    {
      label: 'Generated pin',
      field: 'generatedPin',
      sort: 'asc',
    },
    {
      label: 'Expire Date',
      field: 'expireDate',
      sort: 'asc',
    },

  ],
  selectedVisitorsColumns: [

    {
      label: '',
      field: 'checkOut',
      sort: 'asc'
    },
    {
      label: 'Pass Number',
      field: 'passNumber',
      sort: 'asc'
    },
    {
      label: 'Visitor Identity',
      field: 'visitorIdentity',
      sort: 'asc',
    },
    {
      label: 'Visitor',
      field: 'visitor',
      sort: 'asc',
    },
    {
      label: 'Visitor Mobile',
      field: 'visitorMobile',
      sort: 'asc',
    },


  ]
};

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.GET_ALL_VISITORS:
      return {
        ...state,
        visitors: action.data
      };
    default:
      return state;
  }
};

export default reducer;
